"use client";

import { Sparkles } from "lucide-react";
import { SubscriptionDialog } from "./subscription-dialog";

interface UpgradePromptProps {
    message?: string;
    buttonText?: string;
    compact?: boolean;
    hideIcon?: boolean;
}

export function UpgradePrompt({
    message = "Subscribe to unlock this feature",
    buttonText = "Subscribe · £4.99/mo",
    compact = false,
    hideIcon = false
}: UpgradePromptProps) {
    return (
        <div className={`flex items-center justify-center gap-2 ${compact ? 'py-1' : 'py-3 px-4 bg-secondary/50 rounded-lg border border-border'}`}>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
                {!hideIcon && <Sparkles className="h-4 w-4 text-primary" />}
                <span>{message}</span>
            </div>
            <SubscriptionDialog
                trigger={
                    <button className="inline-flex items-center justify-center rounded-md text-xs font-semibold ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-7 px-3 shadow-xs">
                        {buttonText}
                    </button>
                }
            />
        </div>
    );
}
